<script>
  import '../../../i18n/tag';
  import Locale from '../../mixins/locale';
  import { t } from '../../locale';
  import ZmButton from '../button';
  import { getTextContentFromVNodeList } from '../../utils/util';

  export default {
    name: 'ZmTag',
    mixins: [Locale],
    props: {
      closable: Boolean,
      type: {
        type: String,
        default: 'info'
      },
      disableTransitions: Boolean,
      color: String,
      size: {
        type: String,
        default: 'middle'
      },
      avatar: String,
      deleteText: {
        type: String,
        default() {
          return t('tag.delete') + getTextContentFromVNodeList(this.$slots.default).join('');
        }
      }
    },
    components: {
      ZmButton
    },
    data() {
      return {
        activeIndex: -1,
        isGroup: false
      };
    },
    render() {
      return this.disableTransitions ? this.renderContent()
        : (<transition name="zm-zoom-in-center">
            {this.renderContent()}
          </transition>
      );
    },
    methods: {
      handleClose(event) {
        this.$emit('close', event);
        event.stopPropagation();
      },
      handleEnter(event) {
        this.$emit('enter', event, this.$el);
        event.stopPropagation();
      },
      renderContent() {
        return (
          <span
            class={this.getTagClass()}
            tabindex={this.isGroup ? (this.tagIndex === this.activeIndex ? '0' : '-1') : '-1'}
            escape-dialog-trapped-focus={true}
            style={this.getTagStyl()}>
            {this.avatar
              ? (<span class="zm-tag__avatar">
                {this.avatar.length === 1 ? this.avatar : <img src={this.avatar} alt="User Avatar"/>}
              </span>) : ''
            }
            <span class="zm-tag__label">{this.$slots.default}</span>
            {
              this.closable
                ? <zm-button
                  class="zm-tag__close"
                  ghost
                  size="mini"
                  icon="zm-icon-close"
                  tabindex={this.isGroup ? '-1' : '0'}
                  aria-label={this.deleteText}
                  on-click={($event) => this.handleClose($event)}/> : ''
            }
          </span>
        );
      },
      getTagClass() {
        const classes = ['zm-tag', 'zm-tag--' + (this.type || 'info'), 'zm-tag--' + this.tagSize];
        if (this.closable) {
          classes.push('zm-tag--closable');
        }
        return classes;
      },
      getTagStyl() {
        return {
          'backgroundColor': this.color
        };
      }
    },
    computed: {
      tagSize() {
        return this.size || (this.$ELEMENT || {}).size;
      },
      tagIndex() {
        return this.isGroup ? this._tagGroupList.indexOf(this) : -1;
      }
    },
    mounted() {
      let parent = this.$parent;
      this.isGroup = false;
      while (parent) {
        if (parent.$options.name !== 'ZmTagGroup') {
          parent = parent.$parent;
        } else {
          this.isGroup = true;
          this.tagGroup = parent;
          this._tagGroupList = parent.childrenTags;
          break;
        }
      }
      if (this.isGroup) {
        this.activeIndex = this.tagGroup.activeIndex;
      }
      this.$watch(() => {
        if (this.isGroup) {
          return this.tagGroup.activeIndex;
        }
      }, (newVal) => {
        this.activeIndex = newVal;
        if (newVal === this.tagIndex && this.isGroup) {
          this.$el.focus();
        }
      });
    }
  };
</script>

<style lang="scss">
  @import "./style.scss";
</style>
